var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "truck-summary", style: _vm.containerHeight },
    [
      _c("truck-summary-modal", {
        attrs: {
          isVisible: _vm.isModalVisible,
          startTime: _vm.helper.get(_vm.routes, "0.startTime", null),
          routeDetails: _vm.routeDetails,
          routeIndex: _vm.routeIndex,
        },
        on: {
          onDialogClose: function ($event) {
            _vm.isModalVisible = false
          },
          onUpdateRouteDetails: _vm.updateRouteDetails,
          onUpdateModalVisibility: _vm.updateModalVisibility,
          onResetPlanId: function ($event) {
            _vm.currentPlanId = null
          },
          onFailedOrders: _vm.handleFailedOrders,
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "transfer-truck-dialog",
          attrs: {
            fullscreen: "",
            title: _vm.$t("planning.dialog.transferPlan"),
            visible: _vm.isShowTransferPlanModal,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowTransferPlanModal = $event
            },
            closed: _vm.handleLoadPlanModalClose,
          },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "24px" },
              attrs: { type: "flex", gutter: 20 },
            },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12 } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": "4em",
                        inline: true,
                        size: "mini",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("general.from") } },
                        [
                          !_vm.helper.isUndefined(_vm.$selectedTruck)
                            ? _c(
                                "el-tooltip",
                                { attrs: { placement: "left" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.plateNumber"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .plateNumber || "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.vehicleType"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .vehicleType || "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.columns.truckType")
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .truckType
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.$selectedTruck
                                                  ).truckType
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.truckCommodityType"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .truckCommodityType
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.$selectedTruck
                                                  ).truckCommodityType
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.columns.brandName")
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .brandName
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.$selectedTruck
                                                  ).brandName
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.weightCapacity"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .weight
                                              ? "" +
                                                  _vm.helper.printThousandDecimal(
                                                    _vm.getTruckInfo(
                                                      _vm.$selectedTruck
                                                    ).weight
                                                  )
                                              : 0
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.volumeCapacity"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.$selectedTruck)
                                              .volume
                                              ? "" +
                                                  _vm.helper.printThousandDecimal(
                                                    parseFloat(
                                                      _vm.getTruckInfo(
                                                        _vm.$selectedTruck
                                                      ).volume
                                                    )
                                                  )
                                              : 0
                                          )
                                      ),
                                      _c("br"),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    style: {
                                      "margin-left": _vm.isAutoAssign
                                        ? "20px"
                                        : 0,
                                    },
                                    attrs: { icon: "info-circle" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                disabled: "",
                                filterable: "",
                                placeholder: _vm.$t(
                                  "planning.placeholder.plateNumber"
                                ),
                              },
                              model: {
                                value: _vm.$selectedTruck,
                                callback: function ($$v) {
                                  _vm.$selectedTruck = $$v
                                },
                                expression: "$selectedTruck",
                              },
                            },
                            _vm._l(_vm.$trucks, function (item, truckIndex) {
                              return _c(
                                "el-option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.id === _vm.$selectedTruck,
                                      expression: "item.id === $selectedTruck",
                                    },
                                  ],
                                  key: item.id,
                                  attrs: {
                                    label: item.plateNumber,
                                    value: item.id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.plateNumber))]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [_vm._v(_vm._s(item.vehicleType))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                disabled:
                                  _vm.truckPlanIds &&
                                  _vm.truckPlanIds.length === 0,
                                filterable: "",
                                placeholder: _vm.$t(
                                  "planning.placeholder.printPlanId"
                                ),
                              },
                              model: {
                                value: _vm.currentPlanId,
                                callback: function ($$v) {
                                  _vm.currentPlanId = $$v
                                },
                                expression: "currentPlanId",
                              },
                            },
                            _vm._l(_vm.truckPlanIds, function (planId) {
                              return _c("el-option", {
                                key: planId,
                                attrs: { label: planId, value: planId },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isPlanIdBelongToDifferentUser(_vm.currentPlanId)
                    ? _c(
                        "div",
                        { staticStyle: { margin: "4px 22px" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["far", "eye"], size: "lg" },
                          }),
                          _c("span", { staticClass: "ml-2" }, [
                            _c("i", [
                              _vm._v(_vm._s(_vm.$t("planning.viewOnly"))),
                            ]),
                            _c("b", { staticClass: "ml-1" }, [
                              _vm._v(
                                "- " + _vm._s(_vm.$t("general.createdBy")) + ":"
                              ),
                            ]),
                            _vm._v(" " + _vm._s(_vm.getUsername()) + " "),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "transfer-truck-container" },
                    _vm._l(_vm.routes, function (route, routeIndex) {
                      return _c(
                        "li",
                        {
                          key: "" + route.masterpointId,
                          staticClass: "list-group-item",
                          class: _vm.getRouteClass(route),
                          style: _vm.getRouteStyles(route, true),
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex" } },
                            [
                              _c(
                                "el-col",
                                { staticStyle: { width: "45px" } },
                                [
                                  _c("span", { staticClass: "point-index" }, [
                                    _vm._v(_vm._s(routeIndex + 1)),
                                  ]),
                                  route.waypointType === "P"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: {
                                          "margin-left": "13.5px",
                                        },
                                        attrs: {
                                          icon: "circle",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: { "margin-left": "16px" },
                                        attrs: {
                                          icon: "map-marker",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c("el-col", { staticClass: "route-container" }, [
                                _c(
                                  "span",
                                  { staticClass: "align-top" },
                                  [
                                    route.locked || route.status === "completed"
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "lock" },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "bottom-start",
                                          "popper-options": _vm.popperOptions,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.status"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(_vm._s(route.status)),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.waypointType"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.waypointType." +
                                                        route.waypointType
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.zone"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  route.zone === ""
                                                    ? "-"
                                                    : route.zone
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.district"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.district === ""
                                                      ? "-"
                                                      : route.district
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.address"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getWaypointFromId(
                                                      route.masterpointId,
                                                      "address1"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("general.createdBy")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !_vm.helper.isUndefined(
                                                      route.user
                                                    )
                                                      ? route.user
                                                      : _vm.$userInformation
                                                          .user.name
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.companyName"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getWaypointFromId(
                                                      route.masterpointId,
                                                      "companyName"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("hr"),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.start"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("convertTimezone")(
                                                      route.startTime,
                                                      _vm.$timezone
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.eta"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("convertTimezone")(
                                                      route.estimateTime,
                                                      _vm.$timezone
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.end"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("convertTimezone")(
                                                      route.endTime,
                                                      _vm.$timezone
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.actualFinishDate"
                                                    )
                                                  ) +
                                                  ": "
                                              ),
                                              _vm.getWaypointFromId(
                                                route.masterpointId,
                                                "completedTime"
                                              ) === "0000-00-00 00:00:00"
                                                ? _c("span", [_vm._v(" - ")])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          _vm.getWaypointFromId(
                                                            route.masterpointId,
                                                            "completedTime"
                                                          ),
                                                          _vm.$timezone
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]),
                                            _c("hr"),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.planId"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " + _vm._s(route.planId)
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.projectCode"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "projectCode"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.customerCode"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "customerCode"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.shipmentReference"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.shipmentReference
                                                      ? route.shipmentReference.join(
                                                          ", "
                                                        )
                                                      : ""
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.qty"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "quantity"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.gw"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "weight"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.cbm"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "volume"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.serviceType"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "serviceType"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.commodityType"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getOrderField(
                                                      _vm.getOrderId(route),
                                                      "commodityType"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.remarks"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._l(
                                                  _vm.getOrdersField(
                                                    route.orderId,
                                                    "remarks"
                                                  ),
                                                  function (
                                                    item,
                                                    remarksIndex
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      { key: remarksIndex },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "break-word",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "• " +
                                                                _vm._s(item)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "info-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "break-word d-inline-block display-address ml-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                _vm.getWaypointFromId(
                                                  route.masterpointId,
                                                  "startTime"
                                                ),
                                                _vm.$timezone,
                                                "YY-MM-DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getStartAndEndTime(
                                                route.waypointId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    route.shipmentReference.length === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-inline-block ml-1",
                                          },
                                          [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  route.shipmentReference[0]
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "position-relative",
                                    staticStyle: { top: "-8px" },
                                  },
                                  [
                                    _vm.hasAssemblyMinutes
                                      ? [
                                          _vm._l(
                                            _vm.getOrdersField(
                                              route.orderId,
                                              "remarks"
                                            ),
                                            function (item, remarksIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key: remarksIndex,
                                                  staticClass: "break-word",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "break-word",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "• " + _vm._s(item)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "break-word" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOrderField(
                                                    _vm.getOrderId(route),
                                                    "serviceName"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _c("div", { staticClass: "break-word" }, [
                                      _vm._v(_vm._s(route.displayAddress)),
                                    ]),
                                    _c(
                                      "div",
                                      { class: _vm.isRouteLate(route) },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.eta")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                route.estimateTime,
                                                _vm.$timezone
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.actualFinishDate"
                                            )
                                          ) +
                                          ": "
                                      ),
                                      _vm.getWaypointFromId(
                                        route.masterpointId,
                                        "completedTime"
                                      ) === "0000-00-00 00:00:00"
                                        ? _c("span", [_vm._v(" - ")])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("convertTimezone")(
                                                  _vm.getWaypointFromId(
                                                    route.masterpointId,
                                                    "completedTime"
                                                  ),
                                                  _vm.$timezone
                                                )
                                              )
                                            ),
                                          ]),
                                    ]),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12 } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": "4em",
                        inline: true,
                        size: "mini",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("general.to") } },
                        [
                          !_vm.helper.isUndefined(_vm.targetTruck)
                            ? _c(
                                "el-tooltip",
                                { attrs: { placement: "left" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.plateNumber"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .plateNumber || "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.vehicleType"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .vehicleType || "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.columns.truckType")
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .truckType
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.targetTruck
                                                  ).truckType
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.truckCommodityType"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .truckCommodityType
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.targetTruck
                                                  ).truckCommodityType
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.columns.brandName")
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .brandName
                                              ? "" +
                                                  _vm.getTruckInfo(
                                                    _vm.targetTruck
                                                  ).brandName
                                              : "-"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.weightCapacity"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .weight
                                              ? "" +
                                                  _vm.helper.printThousandDecimal(
                                                    _vm.getTruckInfo(
                                                      _vm.targetTruck
                                                    ).weight
                                                  )
                                              : 0
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.volumeCapacity"
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(
                                            _vm.getTruckInfo(_vm.targetTruck)
                                              .volume
                                              ? "" +
                                                  _vm.helper.printThousandDecimal(
                                                    parseFloat(
                                                      _vm.getTruckInfo(
                                                        _vm.targetTruck
                                                      ).volume
                                                    )
                                                  )
                                              : 0
                                          )
                                      ),
                                      _c("br"),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    style: {
                                      "margin-left": _vm.isAutoAssign
                                        ? "20px"
                                        : 0,
                                    },
                                    attrs: { icon: "info-circle" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-select",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                disabled:
                                  (_vm.truckPlanIds &&
                                    (_vm.truckPlanIds.length === 0 ||
                                      _vm.currentPlanId === null)) ||
                                  _vm.isManualAssignLoading ||
                                  _vm.isAutoAssignLoading,
                                filterable: "",
                                placeholder: _vm.$t(
                                  "planning.placeholder.plateNumber"
                                ),
                              },
                              model: {
                                value: _vm.targetTruck,
                                callback: function ($$v) {
                                  _vm.targetTruck = $$v
                                },
                                expression: "targetTruck",
                              },
                            },
                            _vm._l(_vm.$trucks, function (item) {
                              return _c(
                                "el-option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.id !== _vm.$selectedTruck,
                                      expression: "item.id !== $selectedTruck",
                                    },
                                  ],
                                  key: item.id,
                                  attrs: {
                                    disabled: _vm.isTruckIdExistInGlobal(
                                      item.id
                                    ),
                                    label: item.plateNumber,
                                    value: item.id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.plateNumber))]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.vehicleType +
                                            " " +
                                            (_vm.helper.isNotEmpty(
                                              item.truckCommodityType
                                            )
                                              ? ", " + item.truckCommodityType
                                              : "")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.targetTruck &&
                      _vm.getTruckPlanIdsByTruckId(_vm.targetTruck).length > 0
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    filterable: "",
                                    placeholder: _vm.$t(
                                      "planning.placeholder.printPlanId"
                                    ),
                                  },
                                  model: {
                                    value: _vm.targetPlanId,
                                    callback: function ($$v) {
                                      _vm.targetPlanId = $$v
                                    },
                                    expression: "targetPlanId",
                                  },
                                },
                                _vm._l(
                                  _vm.getTruckPlanIdsByTruckId(_vm.targetTruck),
                                  function (planId) {
                                    return _c("el-option", {
                                      key: planId,
                                      attrs: { label: planId, value: planId },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.isPlanIdBelongToDifferentUser(
                    _vm.targetPlanId,
                    _vm.targetTruck
                  )
                    ? _c(
                        "div",
                        { staticStyle: { margin: "4px 22px" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["far", "eye"], size: "lg" },
                          }),
                          _c("span", { staticClass: "ml-2" }, [
                            _c("i", [
                              _vm._v(_vm._s(_vm.$t("planning.viewOnly"))),
                            ]),
                            _vm.targetPlanId
                              ? _c("b", { staticClass: "ml-1" }, [
                                  _vm._v(
                                    "- " +
                                      _vm._s(_vm.$t("general.createdBy")) +
                                      ":"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getUsername(
                                    _vm.getRoutes(_vm.targetTruck),
                                    _vm.targetPlanId
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "transfer-truck-container" },
                    _vm._l(
                      _vm.getRoutes(_vm.targetTruck),
                      function (route, routeIndex) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.targetTruck &&
                                  _vm.getRoutes(_vm.targetTruck).length > 0 &&
                                  _vm.targetPlanId,
                                expression:
                                  "targetTruck && getRoutes(targetTruck).length > 0 && targetPlanId",
                              },
                            ],
                            key: "" + route.masterpointId,
                            staticClass: "list-group-item",
                            class: _vm.getTargetRouteClass(route),
                            style: _vm.getTargetRouteStyles(route),
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { staticStyle: { width: "45px" } },
                                  [
                                    _c("span", { staticClass: "point-index" }, [
                                      _vm._v(_vm._s(routeIndex + 1)),
                                    ]),
                                    route.waypointType === "P"
                                      ? _c("font-awesome-icon", {
                                          staticClass: "point-type",
                                          staticStyle: {
                                            "margin-left": "13.5px",
                                          },
                                          attrs: {
                                            icon: "circle",
                                            "aria-hidden": "true",
                                            size: "lg",
                                          },
                                        })
                                      : _c("font-awesome-icon", {
                                          staticClass: "point-type",
                                          staticStyle: {
                                            "margin-left": "16px",
                                          },
                                          attrs: {
                                            icon: "map-marker",
                                            "aria-hidden": "true",
                                            size: "lg",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { staticClass: "route-container" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "align-top" },
                                      [
                                        route.locked ||
                                        route.status === "completed"
                                          ? _c("font-awesome-icon", {
                                              attrs: { icon: "lock" },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              placement: "bottom-end",
                                              "popper-options":
                                                _vm.popperOptions,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.status"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(_vm._s(route.status)),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.gMap.waypointType"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.waypointType." +
                                                            route.waypointType
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.zone"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.zone === ""
                                                        ? "-"
                                                        : route.zone
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.gMap.district"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        route.district === ""
                                                          ? "-"
                                                          : route.district
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.address"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getWaypointFromId(
                                                          route.masterpointId,
                                                          "address1"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "general.createdBy"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        !_vm.helper.isUndefined(
                                                          route.user
                                                        )
                                                          ? route.user
                                                          : _vm.$userInformation
                                                              .user.name
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.companyName"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getWaypointFromId(
                                                          route.masterpointId,
                                                          "companyName"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.start"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          route.startTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.eta"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          route.estimateTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.end"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          route.endTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.actualFinishDate"
                                                        )
                                                      ) +
                                                      ": "
                                                  ),
                                                  _vm.getWaypointFromId(
                                                    route.masterpointId,
                                                    "completedTime"
                                                  ) === "0000-00-00 00:00:00"
                                                    ? _c("span", [
                                                        _vm._v(" - "),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              _vm.getWaypointFromId(
                                                                route.masterpointId,
                                                                "completedTime"
                                                              ),
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.planId"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " + _vm._s(route.planId)
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.projectCode"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "projectCode"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.customerCode"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "customerCode"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.shipmentReference"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        route.shipmentReference
                                                          ? route.shipmentReference.join(
                                                              ", "
                                                            )
                                                          : ""
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.qty"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "quantity"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.gw"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "weight"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.cbm"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "volume"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.serviceType"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "serviceType"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.commodityType"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getOrderField(
                                                          _vm.getOrderId(route),
                                                          "commodityType"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.columns.remarks"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._l(
                                                      _vm.getOrdersField(
                                                        route.orderId,
                                                        "remarks"
                                                      ),
                                                      function (
                                                        item,
                                                        remarksIndex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          { key: remarksIndex },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "break-word",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "• " +
                                                                    _vm._s(item)
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "info-circle" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "break-word d-inline-block display-address ml-1",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-inline-block" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    _vm.getWaypointFromId(
                                                      route.masterpointId,
                                                      "startTime"
                                                    ),
                                                    _vm.$timezone,
                                                    "YY-MM-DD"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getStartAndEndTime(
                                                    route.waypointId
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        route.shipmentReference.length === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-inline-block ml-1",
                                              },
                                              [
                                                _vm._v(
                                                  "- " +
                                                    _vm._s(
                                                      route.shipmentReference[0]
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "position-relative",
                                        staticStyle: { top: "-8px" },
                                      },
                                      [
                                        _vm.hasAssemblyMinutes
                                          ? [
                                              _vm._l(
                                                _vm.getOrdersField(
                                                  route.orderId,
                                                  "remarks"
                                                ),
                                                function (item, remarksIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: remarksIndex,
                                                      staticClass: "break-word",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "break-word",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "• " + _vm._s(item)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "break-word" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getOrderField(
                                                        _vm.getOrderId(route),
                                                        "serviceName"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "break-word" },
                                          [_vm._v(_vm._s(route.displayAddress))]
                                        ),
                                        _c(
                                          "div",
                                          { class: _vm.isRouteLate(route) },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("planning.tooltip.eta")
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    route.estimateTime,
                                                    _vm.$timezone
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.tooltip.actualFinishDate"
                                                )
                                              ) +
                                              ": "
                                          ),
                                          _vm.getWaypointFromId(
                                            route.masterpointId,
                                            "completedTime"
                                          ) === "0000-00-00 00:00:00"
                                            ? _c("span", [_vm._v(" - ")])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("convertTimezone")(
                                                      _vm.getWaypointFromId(
                                                        route.masterpointId,
                                                        "completedTime"
                                                      ),
                                                      _vm.$timezone
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.isShowTransferPlanModal = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("general.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.isTransferLoadPlanDisabled,
                    type: "primary",
                    size: "small",
                  },
                  on: { click: _vm.transferLoadPlan },
                },
                [_vm._v(" " + _vm._s(_vm.$t("general.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 8 } },
        [
          _c(
            "el-col",
            { attrs: { id: "sectionTitle" } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c("el-form-item", { staticClass: "w-100" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "mt-0 mb-0 text-center d-inline-block w-100",
                      },
                      [
                        !_vm.helper.isUndefined(_vm.truckInPlan) &&
                        _vm.truckInPlan.orderId &&
                        _vm.truckInPlan.orderId.length > 0
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-options": _vm.popperOptions,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("general.totalOrders")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.truckInPlan.orderId
                                              ? _vm.truckInPlan.orderId.length
                                              : 0
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.columns.planId")
                                          ) + ": "
                                        ),
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.truckInPlan.planId.join(", ")
                                        )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.shipRefs")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm
                                              .getShipRefsFromOrderId(
                                                _vm.truckInPlan.orderId
                                              )
                                              .join(", ")
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("font-awesome-icon", {
                                  staticClass: "d-none d-md-inline",
                                  attrs: { icon: "info-circle" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(
                          " " + _vm._s(_vm.currentTruck.plateNumber) + " "
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionFunction" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      !_vm.$isMobile
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                placement: "top",
                                content: _vm.isReorderingEnabled
                                  ? _vm.$t("planning.disableReordering")
                                  : _vm.$t("planning.enableReordering"),
                              },
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  disabled: _vm.isComponentDisabled(false),
                                },
                                model: {
                                  value: _vm.isReorderingEnabled,
                                  callback: function ($$v) {
                                    _vm.isReorderingEnabled = $$v
                                  },
                                  expression: "isReorderingEnabled",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.tooltip.getUpdatedETA"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      _vm.isComponentDisabled(false) ||
                                      _vm.isCalculateETADisabled,
                                    size: "mini",
                                  },
                                  on: { click: _vm.updateETA },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: "clock",
                                      "aria-hidden": "true",
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { width: "calc(100% - 100px)" } },
                    [
                      _c("el-input", {
                        staticClass: "w-100",
                        attrs: {
                          clearable: "",
                          size: "mini",
                          placeholder: _vm.$t(
                            "planning.placeholder.searchRouteByShipRef"
                          ),
                          disabled: _vm.isComponentDisabled(false),
                        },
                        on: { input: _vm.handleSearchShipRef },
                        model: {
                          value: _vm.searchText,
                          callback: function ($$v) {
                            _vm.searchText = $$v
                          },
                          expression: "searchText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-block",
              attrs: { id: "sectionUtilities" },
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            disabled: _vm.isComponentDisabled(true),
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.printPlanId"
                            ),
                          },
                          model: {
                            value: _vm.currentPlanId,
                            callback: function ($$v) {
                              _vm.currentPlanId = $$v
                            },
                            expression: "currentPlanId",
                          },
                        },
                        _vm._l(_vm.truckPlanIds, function (planId) {
                          return _c("el-option", {
                            key: planId,
                            attrs: { label: planId, value: planId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.printPlanId"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.isComponentDisabled(false),
                                    type: "success",
                                    size: "mini",
                                  },
                                  on: { click: _vm.printPlanId },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "print", size: "lg" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.isComponentDisabled(false) ||
                              _vm.isDriverSelectionDisabled,
                            filterable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.searchDriver"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleCurrentDriverChanges(true)
                            },
                          },
                          model: {
                            value: _vm.currentDriver,
                            callback: function ($$v) {
                              _vm.currentDriver = $$v
                            },
                            expression: "currentDriver",
                          },
                        },
                        _vm._l(_vm.driversList, function (driver) {
                          return _c(
                            "el-option",
                            {
                              key: driver.RecId,
                              attrs: {
                                disabled: _vm.blockedDrivers.includes(
                                  driver.RecId
                                ),
                                label:
                                  driver.UserName +
                                  " [" +
                                  driver.Carplate +
                                  "] ",
                                value: driver.RecId,
                              },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(
                                  _vm._s(driver.UserName) +
                                    " [" +
                                    _vm._s(driver.Carplate) +
                                    "] "
                                ),
                              ]),
                              driver.UserName
                                ? _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "" +
                                            (driver["MonitorType"] === "M"
                                              ? _vm.$t("planning.mobile")
                                              : _vm.$t("planning.noMonitor"))
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("planning.assignToDriver"),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "disabled-btn-wrapper" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    padding: "5px 13px !important",
                                  },
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      _vm.isComponentDisabled(false) ||
                                      _vm.isAssignDriverDisabled,
                                    size: "mini",
                                  },
                                  on: { click: _vm.assignToDriver },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: "people-carry",
                                      "aria-hidden": "true",
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "d-none d-md-inline-block" },
                    [
                      _c("el-tooltip", { attrs: { placement: "top" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm.isUnassignBtnDisabled
                              ? [
                                  _vm.isPlanIdRoutesAllUnassigned
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.unassignedRoutes"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  _vm.isPlanIdRoutesSomeCompleted
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.completedRoutes"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.tooltip.unassignPlanId"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _c(
                          "span",
                          { staticClass: "disabled-btn-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { padding: "5px 13px !important" },
                                attrs: {
                                  type: "success",
                                  disabled:
                                    _vm.isComponentDisabled(false) ||
                                    _vm.isUnassignBtnDisabled,
                                  size: "mini",
                                },
                                on: { click: _vm.unassignPlanId },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: "hands",
                                    "aria-hidden": "true",
                                    size: "lg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isPlanIdBelongToDifferentUser(_vm.currentPlanId)
            ? _c(
                "el-col",
                { staticStyle: { margin: "4px 22px" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["far", "eye"], size: "lg" },
                  }),
                  _c("span", { staticClass: "ml-2" }, [
                    _c("i", [_vm._v(_vm._s(_vm.$t("planning.viewOnly")))]),
                    _c("b", { staticClass: "ml-1" }, [
                      _vm._v("- " + _vm._s(_vm.$t("general.createdBy")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.getUsername()) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            [
              _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "list-group",
                    style: { height: _vm.listHeight },
                    attrs: {
                      disabled:
                        _vm.helper.isNotEmpty(_vm.searchText) ||
                        !_vm.isReorderingEnabled ||
                        _vm.isPlanIdBelongToDifferentUser(_vm.currentPlanId),
                      tag: "ul",
                    },
                    on: {
                      change: _vm.handleRouteChanges,
                      update: function ($event) {
                        _vm.$anyChanges = true
                      },
                    },
                    model: {
                      value: _vm.routes,
                      callback: function ($$v) {
                        _vm.routes = $$v
                      },
                      expression: "routes",
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.routes, function (route, routeIndex) {
                      return _c(
                        "li",
                        {
                          key: "" + route.masterpointId,
                          staticClass: "list-group-item",
                          class: _vm.getRouteClass(route),
                          style: _vm.getRouteStyles(route),
                          on: {
                            click: function ($event) {
                              return _vm.onRouteClick(routeIndex)
                            },
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex" } },
                            [
                              _c(
                                "el-col",
                                { staticStyle: { width: "45px" } },
                                [
                                  _c("span", { staticClass: "point-index" }, [
                                    _vm._v(_vm._s(routeIndex + 1)),
                                  ]),
                                  route.waypointType === "P"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: {
                                          "margin-left": "13.5px",
                                        },
                                        attrs: {
                                          icon: "circle",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      })
                                    : _c("font-awesome-icon", {
                                        staticClass: "point-type",
                                        staticStyle: { "margin-left": "16px" },
                                        attrs: {
                                          icon: "map-marker",
                                          "aria-hidden": "true",
                                          size: "lg",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c("el-col", { staticClass: "route-container" }, [
                                _c(
                                  "span",
                                  { staticClass: "align-top" },
                                  [
                                    route.locked ||
                                    route.status.toUpperCase() === "COMPLETED"
                                      ? _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "lock" },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          placement: "top",
                                          "popper-options": _vm.popperOptions,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.waypointType"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.waypointType." +
                                                        route.waypointType
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.gMap.district"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.district === ""
                                                      ? "-"
                                                      : route.district
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.planId"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " + _vm._s(route.planId)
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.shipmentReference"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    route.shipmentReference
                                                      ? route.shipmentReference.join(
                                                          ", "
                                                        )
                                                      : ""
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("general.createdBy")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !_vm.helper.isUndefined(
                                                      route.user
                                                    )
                                                      ? route.user
                                                      : _vm.$userInformation
                                                          .user.name
                                                  )
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.columns.remarks"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _vm._l(
                                                  _vm.getOrdersField(
                                                    route.orderId,
                                                    "remarks"
                                                  ),
                                                  function (
                                                    item,
                                                    remarksIndex
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      { key: remarksIndex },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "break-word",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "• " +
                                                                _vm._s(item)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        _c("font-awesome-icon", {
                                          staticClass: "d-none d-md-inline",
                                          attrs: { icon: "info-circle" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "break-word d-inline-block display-address",
                                    class: { "ml-1": !_vm.$isMobile },
                                    style: {
                                      width:
                                        "calc(100% - " +
                                        (route.locked ||
                                        route.status.toUpperCase() ===
                                          "COMPLETED"
                                          ? 65
                                          : 47) +
                                        "px)",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                _vm.getWaypointFromId(
                                                  route.masterpointId,
                                                  "startTime"
                                                ),
                                                _vm.$timezone,
                                                "YY-MM-DD"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getStartAndEndTime(
                                                route.waypointId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    route.shipmentReference.length === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-inline-block ml-1",
                                          },
                                          [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  route.shipmentReference[0]
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "float-right cursor-pointer d-none",
                                    class: {
                                      "d-md-inline-block":
                                        !_vm.isRouteBelongToDifferentUser(
                                          route
                                        ) &&
                                        !(
                                          _vm.isManualAssignLoading ||
                                          _vm.isAutoAssignLoading
                                        ),
                                    },
                                    staticStyle: { "margin-left": "8px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openRouteDetails(
                                          routeIndex,
                                          route
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: "edit",
                                        "aria-hidden": "true",
                                        size: "lg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "position-relative",
                                    staticStyle: { top: "-8px" },
                                  },
                                  [
                                    _vm.hasAssemblyMinutes
                                      ? [
                                          _vm._l(
                                            _vm.getOrdersField(
                                              route.orderId,
                                              "remarks"
                                            ),
                                            function (item, remarksIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key: remarksIndex,
                                                  staticClass: "break-word",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "break-word",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "• " + _vm._s(item)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "break-word" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOrderField(
                                                    _vm.getOrderId(route),
                                                    "serviceName"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _c("div", { staticClass: "break-word" }, [
                                      _vm._v(_vm._s(route.displayAddress)),
                                    ]),
                                    _c(
                                      "div",
                                      { class: _vm.isRouteLate(route) },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.eta")
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("convertTimezone")(
                                                route.estimateTime,
                                                _vm.$timezone
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.actualFinishDate"
                                            )
                                          ) +
                                          ": "
                                      ),
                                      _vm.getWaypointFromId(
                                        route.masterpointId,
                                        "completedTime"
                                      ) === "0000-00-00 00:00:00"
                                        ? _c("span", [_vm._v(" - ")])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("convertTimezone")(
                                                  _vm.getWaypointFromId(
                                                    route.masterpointId,
                                                    "completedTime"
                                                  ),
                                                  _vm.$timezone
                                                )
                                              )
                                            ),
                                          ]),
                                    ]),
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }